import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    TabContent, TabPane, Nav, NavItem, NavLink,
    Button
} from "reactstrap"
import classnames from 'classnames'
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import moment from "moment"

import apiResponse from '../../../../../services/apiResponse';

import DetailBloc from '../Blocs/DetailBloc'

class KomptLengkap extends Component {
    
    detailBloc = new DetailBloc()
    
    constructor(props) {
        super(props)
        this.state = {
            detail:{},
            acData : {},
            acDetail : [{}],
            stankomData : [{}],
            levelComps: [
                {
                    name: "",
                    level : 1
                },
            ],
            activeTab: '1',
        }
    }
    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }
    loadAcData = async () => {
        const query = {
            uuid: this.props.uuid
        }
        // console.log(query)
        await this.detailBloc.fetchAcDetail(query)
    }
    loadAcDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }
        // console.log(query)
        await this.detailBloc.fetchAcData(query)
    }
    loadStankom = async () => {
        const query = {
            posuuid: this.props.posuuid
        }
        // console.log(query)
        await this.detailBloc.fetchStankom(query)
    }
    componentDidMount() {
        this.loadAcData()
        this.loadAcDetail()
        this.loadStankom()
        this.detailBloc.acDataChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log(response)
                        this.setState({
                            acData : response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.detailBloc.acDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log(response)
                        this.setState({
                            acDetail : response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.detailBloc.stankomChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log('stankom')
                        // console.log('stankom', response)
                        this.setState({
                            stankomData : response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

       
    }
    reformatLevel = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["name"] = data.level_name;
          newObj["level"] = data.level_no;
      
          return newObj;
        });
    }

    render() {
        return (
            <Fragment>
                {/* <h4>{this.props.posuuid}</h4> */}

                <table className="table table-bordered">
                    <thead>
                        <tr style={{background:"#808e95"}}>
                            <th className="text-white text-center">No.</th>
                            <th className="text-white">Deskripsi Kompetensi</th>
                            <th colSpan="5" className="text-center text-white">Tingkat Kemahiran</th>
                        </tr>
                    </thead>
                    <tbody style={{background:"#e2f1f8"}}>
                        {
                            (Array.isArray(this.state.stankomData) && this.state.stankomData.length)?
                            this.state.stankomData.map((data,index)=>{       
                                return(
                                    <tr>
                                        <td className="text-center">{(index+1)}</td>
                                        <td>{data.competence_name}</td>
                                        {/* <td className="text-center" style={{background:(data.stancom_competence_level==0)?'#28a745':''}}>0</td> */}
                                        <td className={`text-center ${(data.stancom_competence_level==1)?'text-white':''}`} style={{background:(data.stancom_competence_level==1)?'#28a745':''}}>1</td>
                                        <td className={`text-center ${(data.stancom_competence_level==1)?'text-white':''}`} style={{background:(data.stancom_competence_level==2)?'#28a745':''}}>2</td>
                                        <td className={`text-center ${(data.stancom_competence_level==3)?'text-white bg-success':''}`}>3</td>
                                        <td className={`text-center ${(data.stancom_competence_level==4)?'text-white':''}`} style={{background:(data.stancom_competence_level==4)?'#28a745':''}}>4</td>
                                        <td className={`text-center ${(data.stancom_competence_level==5)?'text-white':''}`} style={{background:(data.stancom_competence_level==5)?'#28a745':''}}>5</td>
                                    </tr>
                                )  
                            })
                            : <tr><td colSpan="7"><Shimmer><div style={{width: 500, height: 30}}></div></Shimmer></td></tr>
                        }
                    </tbody>
                </table> 
                                     
            </Fragment>
        )
    }
}

//export default IndexView
export default KomptLengkap;